const GIGABYTE = 1024 * 1024 * 1024;
const PROFILES = {
    'low-tablet': {
        id: 'low-tablet',
        maxTextureEdge: 256,
        textureMemoryBytes: 1 * GIGABYTE,
        speed: 10,
    },
    low: {
        id: 'low',
        maxTextureEdge: 256,
        textureMemoryBytes: 2 * GIGABYTE,
        speed: 30,
    },
    medium: {
        id: 'medium',
        maxTextureEdge: 2048,
        textureMemoryBytes: 8 * GIGABYTE,
        speed: 60,
    },
    high: {
        id: 'high',
        maxTextureEdge: 2048,
        textureMemoryBytes: 32 * GIGABYTE,
        speed: 100,
    },
    'high-texture-4096': {
        id: 'high-texture-4096',
        maxTextureEdge: 4096,
        textureMemoryBytes: 32 * GIGABYTE,
        speed: 100,
        internal: true,
    },
};
const DEFAULT_PROFILE_ID = 'high';
let activeProfileId = DEFAULT_PROFILE_ID;
function getGpuCapabilityProfiles() {
    return Object.values(PROFILES);
}
function getGpuCapabilityProfile(id) {
    const profile = Object.prototype.hasOwnProperty.call(PROFILES, id)
        ? PROFILES[id]
        : undefined;
    if (!profile) {
        throw new Error(`gpuCapabilityProfiles: there is no profile named ${id}`);
    }
    return profile;
}
function setActiveGpuCapabilityProfile(id) {
    getGpuCapabilityProfile(id);
    activeProfileId = id;
}
function getActiveGpuCapabilityProfile() {
    return getGpuCapabilityProfile(activeProfileId);
}
function resetActiveGpuCapabilityProfile() {
    activeProfileId = DEFAULT_PROFILE_ID;
}
function gridLimitsOfProfile(profile, bytesPerVoxel) {
    const limits = { maxEdge: profile.maxTextureEdge };
    if (bytesPerVoxel > 0 && profile.textureMemoryBytes > 0) {
        limits.maxVoxelCount = Math.floor(profile.textureMemoryBytes / bytesPerVoxel);
    }
    return limits;
}
export { getGpuCapabilityProfile, getGpuCapabilityProfiles, setActiveGpuCapabilityProfile, getActiveGpuCapabilityProfile, resetActiveGpuCapabilityProfile, gridLimitsOfProfile, DEFAULT_PROFILE_ID as defaultGpuCapabilityProfileId, };
